<template>
  <div class="view-lives py-5 text-light">
    <action-dispatcher class="px-4 px-lg-5" action="lives/getLive">
      <div class="row" v-if="live.yt_link">
        <div class="col-lg-8 py-3">
          <div id="ytVideo" class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              :src="
                `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0&controls=0`
              "
              allowfullscreen
              allow="autoplay"
            ></iframe>
          </div>

          <h3 class="font-weight-normal mt-4">{{ live.title }}</h3>
          <p>{{ liveDate }}</p>
        </div>

        <div class="col-lg-4 py-3">
          <div class="embed-responsive chat">
            <iframe
              class="embed-responsive-item"
              :src="chatUrl"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </action-dispatcher>

    <action-dispatcher action="lives/getLiveCategories">
      <action-dispatcher
        v-for="category in liveCategories"
        :key="category.id"
        action="lives/getLives"
        :parameters="category.id"
        class="my-4"
      >
        <div
          v-if="category.lives && category.lives.length"
          class="px-4 px-lg-5 py-3"
        >
          <h5>
            {{ category.name }}
          </h5>
        </div>

        <div class="position-relative">
          <div class="px-4 px-lg-5">
            <swiper :navigation="true" :breakpoints="breakpoints">
              <swiper-slide
                v-for="live in sortLives(category.lives || [])"
                :key="live.id"
              >
                <live-slide :live="live" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </action-dispatcher>
    </action-dispatcher>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Swiper from "@/components/Swiper";
import SwiperSlide from "@/components/SwiperSlide";
import LiveSlide from "@/components/lives/LiveSlide";
import { youtubeParser } from "@/functions/helpers";
import get from "lodash/get";

export default {
  components: {
    Swiper,
    SwiperSlide,
    LiveSlide
  },
  data() {
    return {
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 3
        },
        1200: {
          slidesPerView: 4
        },
        1600: {
          slidesPerView: 5
        }
      }
    };
  },
  computed: {
    ...mapState("lives", ["live", "liveCategories"]),
    liveDate() {
      return new Date(this.live.created_at).toLocaleString("pt-br", {
        day: "numeric",
        year: "numeric",
        month: "long"
      });
    },
    youtubeId() {
      return youtubeParser(get(this.live, "yt_link"));
    },
    chatUrl() {
      return `https://www.youtube.com/live_chat?v=${this.youtubeId}&embed_domain=${document.location.hostname}`;
    }
  },
  methods: {
    sortLives(lives) {
      return [...lives].sort((a, b) => b.order - a.order);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-lives {
  .embed-responsive.chat {
    padding-top: 116%;
  }
}
</style>
